import React, { useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { Grid, Button } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import {  useDispatch, useSelector } from 'react-redux';
import { changePassword, checkResetHash } from '../actions/password.actions';
import { addAlert } from '../actions/alerts.action';

const ChangePassword = props => {
  const { t } = useTranslation();
  const [ password, setPassword ] = useState('');
  const [ passwordSecondTime, setPasswordSecondTime ] = useState('');
  const alerts = useSelector(state => state.alerts);
  const resetHash = props.match.params.hash;
  const employee = useSelector(state => state.employee);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkResetHash(resetHash));
  }, [ dispatch, resetHash ]);

  const handleOnChangePassword = event => setPassword(event.target.value);
  const handleOnChangePasswordAgain = event => setPasswordSecondTime(event.target.value);

  const handleSend = () => {
    if (password && password === passwordSecondTime) {
      dispatch(changePassword(resetHash, { password }, props.history));
    } else {
      dispatch(addAlert( { message: t('common.alert.passwords_missmatch'), severity: 'error' }));
    }
  };

  const useStyles = makeStyles({
    root: {
      justify: 'center',
      minHeight: '100vh'
    },
    paper: {
      padding: '20px',
      width: '250px'
    },
    textField: {
      width: '100%',
      marginTop: '10px',
      marginBottom: '10px'
    },
    helpText: {
      marginTop: '20px'
    }
  });

  const classes = useStyles();

  // TODO: ez mit csinál, miért van, mire jó?
  if (!employee || alerts
    .filter(alert => alert.message === 'Invalid link' ||
      alert.message === 'Link expired').length !== 0) {
    return <></>;
  }

  return (
    <Grid container className={ classes.root } justifyContent="center" alignItems="center">
      <Paper className={ classes.paper }>
        <Grid container direction={ 'column' }>
          <Typography variant="h5" component="h3">
            <Trans i18nKey={ 'change_password.welcome' } values={ { name: employee.name } }/>
          </Typography>
          <Typography className={ classes.helpText } component="h6">
            { t('change_password.description') }
          </Typography>
          <TextField
            type="password"
            label={ t('change_password.label.password') }
            className={ classes.textField }
            onChange={ handleOnChangePassword }
          />
          <TextField
            type="password"
            label={ t('change_password.label.password_again') }
            className={ classes.textField }
            onChange={ handleOnChangePasswordAgain }
          />
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
        >
          <Button onClick={ handleSend } color='primary' >
            { t('change_password.button.send') }
          </Button>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default ChangePassword;
